
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
  name: 'jsonData'
})

export class JsonDataPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {

  }
  transform(data: any) {
    var result = JSON.stringify(data, null, 2);
    if (data == "") {
      return null;
    }
    return JSON.stringify(data, null, 2);
  }
}
